import { zIndex } from '../../constants'

export default function Message({ count, ...rest }) {
  return (
    <>
      <div className='wrapper'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          xlink='http://www.w3.org/1999/xlink'
          width='3em'
          height='3em'
          preserveAspectRatio='xMidYMid meet'
          viewBox='0 0 24 24'
          {...rest}
        >
          <path d='M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2z'></path>
        </svg>
        <span className='count'>{count}</span>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
        }
        .count {
          color: black;
          z-index: ${zIndex.zMax};
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          top: 0.6rem;
          font-weight: bolder;
        }
      `}</style>
    </>
  )
}
